<div class="footer-banner-container">
    <div class="footer-banner-top">
        <div>Brought to you by</div>
        <img src="/assets/images/vs-logo-black.png" alt="Logo">
    </div>
    <div class="footer-banner-bottom">
        Website © {{ year }} Victim Support Registered charity number: 298028
    </div>
</div>
